import { useInfiniteQuery } from 'react-query';
import { GetActivitiesDto } from '../UserActivityTypes';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { regroupItems } from '../UserActivityHelpers';

export const USER_ACTIVITY_QUERY_KEY = 'userActivity';

const getActivities = async (
  clientId: string,
  hideAutomatic: boolean,
  pageParam?: number,
): Promise<GetActivitiesDto> => {
  const data = await authFetch(
    urlWithParams('/Consumer/ActivityLog', { clientId, lastEventId: pageParam, hideAutomatic }),
  );

  return regroupItems(data);
};

export const useActivities = (clientId, hideAutomatic) => {
  return useInfiniteQuery(
    [USER_ACTIVITY_QUERY_KEY, clientId, hideAutomatic],

    ({ pageParam }) => getActivities(clientId, hideAutomatic, pageParam),

    {
      getNextPageParam: lastGroup => {
        if (lastGroup.Items.length > 0 && lastGroup.LastEventId > -1) {
          return lastGroup.LastEventId;
        }

        return undefined;
      },

      cacheTime: 0,
    },
  );
};
